export const PosTablePaginationFooterHeight =
  '--pos-table-pagination-footer-height';
